<template>
  <div class="flex">
    <div
      :class="[
        'w-6 h-6 won-tag-light-gray rounded-l-md border-r border-[#DBDBDC]',
        'cursor-pointer flex items-center justify-center select-none',
      ]"
      @click="applyTextMinus"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="won-color-gray stroke-2 w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
      </svg>
    </div>
      
      <FloatingElement>
          <template #trigger>
              <div
                  :class="[
                    'w-[30px] h-6 flex justify-center items-center cursor-pointer',
                    'won-tag-light-gray select-none',
                  ]"
              >
                  <svg class="won-color-gray stroke-2 w-4 h-4" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.125 0V2.25H11.375V11.25H9.125V2.25H5.375V0H15.125ZM0.875001 3.75H7.625V6H5.375V11.25H3.125V6H0.875001V3.75Z" fill="#444C58"/>
                  </svg>
              </div>
          </template>
          
          <div class="max-h-[220px] overflow-y-scroll bg-white rounded shadow-card flex flex-col gap-[6px]">
              <div
                  class="text-won-black font-[14px] hover:bg-won-gray-light leading-[18px] pl-2 pr-3 cursor-pointer"
                  v-for="fontSize in FONT_SIZE_OPTIONS"
                  @click="() => setFontSize(fontSize)"
              >
                  <span>{{ fontSize }}</span>
              </div>
          </div>
      </FloatingElement>

    <div
      :class="[
        'w-6 h-6 won-tag-light-gray rounded-r-md border-l border-[#DBDBDC]',
        'cursor-pointer flex items-center justify-center select-none',
      ]"
      @click="applyTextPlus"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="won-color-gray stroke-2 w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useBuilderStyles } from '../../store/builder-style.store'
import { useTiptapStore } from '../../store/tiptap.store'

import FloatingElement from "../library/floting-element.vue"

const tiptap = useTiptapStore()
const { editor } = storeToRefs(tiptap) 

const builderStyle = useBuilderStyles()
const { nameStyles } = storeToRefs(builderStyle)

const FONT_SIZE_MAX = 29
const FONT_SIZE_MIN = 14

const FONT_SIZE_OPTIONS = [14, 16, 18, 20, 22, 24, 26, 28, 29]

let currentSelectedFontSize = computed(() => {
  let selectionFontSize = editor.value.getAttributes('textStyle')?.fontSize;
  
  if(selectionFontSize != null) {
      return selectionFontSize.replace('px', '')
  }else if( editor.value.options.isDocumentName ){
      return nameStyles.value.fontSize.replace('px', '')
  }else{
      return 14
  }
})

const applyTextPlus = () => {
  const currentSelectionIsEmpty = editor.value ? editor.value.view.state.selection.empty : true
  if(currentSelectionIsEmpty) return builderStyle.textPlus()

  let newSize = Math.min(parseInt(currentSelectedFontSize.value) + 1, FONT_SIZE_MAX)
  editor.value.chain().focus().setFontSize(newSize +'px').run()
}

const applyTextMinus = () => {
  const currentSelectionIsEmpty = editor.value ? editor.value.view.state.selection.empty : true
  if(currentSelectionIsEmpty) return builderStyle.textMinus()

  let newSize = Math.max(parseInt(currentSelectedFontSize.value) - 1, FONT_SIZE_MIN)
  editor.value.chain().focus().setFontSize(newSize +'px').run()
}

const setFontSize = (fontSize) => {
    const currentSelectionIsEmpty = editor.value ? editor.value.view.state.selection.empty : true
    if(currentSelectionIsEmpty) return builderStyle.applyFontSize(fontSize)

    let newSize = Math.max(parseInt(fontSize), FONT_SIZE_MIN)
    editor.value.chain().focus().setFontSize(newSize +'px').run()
}
</script>
